import type { Page } from '@shared/types/Tilelist';

export interface Pagination {
    currentPage: number;
    currentOffset: number;
    lastPage: number;
}

/**
 *
 *
 *
 *
 */
export const calculatePage = (offset: number, maxItemsPerPage: number, threshold: number) => {
    const probablePage = Math.floor(offset / maxItemsPerPage);
    const isOffsetPassedThreshold = offset % maxItemsPerPage >= threshold;
    const determinedPage = isOffsetPassedThreshold ? probablePage + 1 : probablePage;
    return determinedPage + 1;
};

/**
 *
 */
export const calculateLastPage = (itemCount: number, maxItemsPerPage: number) => {
    return Math.ceil(itemCount / maxItemsPerPage);
};

export const calculateNextOffset = (offset: number, maxItemsPerPage: number, itemCount: number) => {
    const possibleNextOffset = offset + maxItemsPerPage;
    return possibleNextOffset <= itemCount ? possibleNextOffset : null;
};

/*                                                                           */
export const calculatePreviousOffset = (offset: number, maxItemsPerPage: number) => {
    const previousOffset = offset - maxItemsPerPage;
    return Math.max(previousOffset, 0);
};
export const calculateLastPageOffset = (itemCount: number, maxItemsPerPage: number) => {
    const lastPage = calculateLastPage(itemCount, maxItemsPerPage);
    const lastPageOffset = (lastPage - 1) * maxItemsPerPage;
    return Math.min(itemCount, lastPageOffset);
};

export const isOffsetInLastPage = (offset: number, maxItemsPerPage: number, itemCount: number, threshold: number) => {
    const beginningOfLastPageOffset = calculateLastPageOffset(itemCount, maxItemsPerPage);
    const lastPageOffset = beginningOfLastPageOffset - threshold;
    return offset >= lastPageOffset;
};

export interface IntentCounts {
    rankedCount: number;
    sponsoredCount: number;
    /*                                                                                              */
    pageItemCount?: number;
}

/**
 *
 *
 *
 *
 *
 */
export function hasMoreThanOnePage(
    { rankedCount, sponsoredCount, pageItemCount }: IntentCounts,
    offset: number,
): boolean {
    if (pageItemCount !== undefined) {
        return offset > 0 || offset + pageItemCount < rankedCount;
    }
    const PER_PAGE = 120;
    const perPageWithSPA = PER_PAGE - sponsoredCount;
    return rankedCount + sponsoredCount > perPageWithSPA;
}

export function getPagination(
    { rankedCount, sponsoredCount }: { rankedCount: number; sponsoredCount: number },
    page: Page,
): Pagination {
    const PER_PAGE = 120;
    const THRESHOLD = PER_PAGE / 2;
    const currentOffset = Number.parseInt(page.o || '0', 10);
    const perPageWithSPA = PER_PAGE - sponsoredCount;
    const currentPage = calculatePage(currentOffset, perPageWithSPA, THRESHOLD);
    const itemCount = rankedCount;
    const lastPage = calculateLastPage(itemCount, perPageWithSPA);

    return {
        currentPage,
        currentOffset,
        lastPage,
    };
}
